import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Lightbulb } from "@faire/web--source/slate/icons/foundation/Lightbulb";
import React from "react";

import { SelfServeNodes } from "../../types";

export const useHowFaireWorksBrandNodes = (): SelfServeNodes => {
  const { strictLocalize } = useStrictLocalization();
  const articles = useArticles();
  return {
    HowFaireWorks: {
      id: "HowFaireWorks",
      label: strictLocalize({
        defaultMessage: "How Faire works",
        description: {
          text: "A top level issue node in the full page self-serve experience of Faire's Help Center",
        },
      }),
      icon: <Lightbulb fontSize="24px" color="faireBlack" />,
      articles: [
        articles.FaireDirect.FAIRE_DIRECT,
        articles.FaireDirect.EMAIL_AUTOMATIONS,
        articles.FaireDirect.EMAIL_CAMPAIGN,
      ],
      level: 1,
      sidebarTitle: strictLocalize({
        defaultMessage: "How Faire works issue",
        description: {
          text: "Title for displaying the issue on the order summary sidebar",
        },
      }),
    },
  };
};
